import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import Article from 'src/smoothr-web-app-core/models/Article';
import ArticleGroup from 'src/smoothr-web-app-core/models/ArticleGroup';
import ArticleOption from 'src/smoothr-web-app-core/models/ArticleOption';
import OptionGroup from 'src/smoothr-web-app-core/models/OptionGroup';
import Order from 'src/smoothr-web-app-core/models/Order';
import { OrderUtils } from 'src/smoothr-web-app-core/utils/order-utils';
import { numberD, numberToCurrency } from 'src/smoothr-web-app-core/utils/utils';

@Component({
	selector: 'app-choose-size-of-product',
	templateUrl: './choose-size-of-product.component.html',
	styleUrls: ['./choose-size-of-product.component.scss'],
})
export class ChooseSizeOfProductComponent {
	public articleGroup: ArticleGroup;
	public optionGroup: OptionGroup;
	public order: Order;
	public listOfArticleOptions: ArticleOption[] = [];
	numberToCurrency = numberToCurrency;
	OrderUtils = OrderUtils;

	constructor(private modalCtrl: ModalController) {}
	static async show(
		modalCtrl: ModalController,
		articleGroup: ArticleGroup,
		optionGroup: OptionGroup,
		order: Order
	): Promise<{ value: ArticleOption[]; isCheckout: boolean }> {
		const modal = await modalCtrl.create({
			cssClass: 'choose-size-modal',
			component: ChooseSizeOfProductComponent,
			componentProps: {
				articleGroup,
				optionGroup,
				order,
			},
			showBackdrop: true,
			backdropDismiss: true,
		});
		await modal.present();

		const result = (await modal.onDidDismiss()).data;
		return result;
	}
	addOption(event: ArticleOption, optionGroup: OptionGroup) {
		if (this.listOfArticleOptions.find(it => it.article._id === event.article._id)) {
			this.listOfArticleOptions = this.listOfArticleOptions.filter(it => it.article._id !== event.article._id);
		} else {
			if (optionGroup.limit === 1) {
				const findArticleOption = this.listOfArticleOptions.find(it => it.group === optionGroup._id);
				if (!findArticleOption) {
					this.listOfArticleOptions.push(event);
				} else {
					this.listOfArticleOptions = this.listOfArticleOptions.filter(it => it.article._id !== findArticleOption.article._id);
					this.listOfArticleOptions.push(event);
				}
			} else {
				this.listOfArticleOptions.push(event);
			}
		}
	}
	totalPrice() {
		if (this.order) {
			const price = this.listOfArticleOptions.map(it => numberD(it.article.price)).reduce((a, b) => a + b, 0);
			// return numberToCurrency(OrderUtils.orderTotalPrice(this.order, true, true, null) + price, this.order.currency);
			return numberToCurrency(price, this.order.currency);
		}
		return '';
	}
	dismiss() {
		this.modalCtrl.dismiss();
	}
	addToBasket() {
		this.modalCtrl.dismiss({ value: this.listOfArticleOptions, isCheckout: false });
	}
	addToBasketAndCheckout() {
		if (this.listOfArticleOptions.length > 0) {
			this.modalCtrl.dismiss({ value: this.listOfArticleOptions, isCheckout: true });
		}
	}
}
